<template>
  <div class="box5">
    <pageTitle
      title="8大实战项目 拓宽就业领域"
      text="覆盖教育、物流、影音、社区生活、养老、医疗、<br/>电商、系统工具等8大领域，拿来即用"
      titleColor="#000D4D"
      titColor="#5A628A"
    />

    <div class="subject-box">
      <div class="scorll-box6">
        <div class="nav-box">
          <div
            class="nav"
            :class="{ 'cur-nav': cur == index }"
            v-for="(item, index) in projectList"
            :key="index"
            @click="changeCur(index)"
          >
            {{ item.name }}
          </div>
          <div class="gray"></div>
        </div>
      </div>
      <div  class="swiper-box">
        <swiper :options="swiperOption" ref="mySwiper" class="swiperitems" @click="showPop">
          <swiper-slide
            class="swiperwrap"
            v-for="(item, index) in projectList"
            :key="index"
          >
            <div class="item-wrapper">
              <div class="item">
                <img :src="item.img" alt="" />
                <p class="text1">【{{item.name}}】{{item.type}}</p>
                <p class="text2">{{item.desc}}</p>
                <div class="expand" :key="index">
                  <div class="line"></div>
                  <span>查看全部</span>
                </div>
              </div>
            </div>		
          </swiper-slide>
        </swiper>
        <div class="seek-btn" @click="openDetail('了解实战项目详情')">
          了解实战项目详情
        </div>
      </div>
    </div>

    <van-popup v-model="show" position="bottom" round>
      <div class="project-wrapper">
        <div class="project-content">
          <div class="pro-img">
            <div class="img1-wrapper"><img class="img1" @click.stop="show = false" src="../../../assets/coursePage/harmony/box5/close.png" alt="" /></div>
            <div><img class="img2" :src="project.img" alt="" /></div>
          </div>
          <div class="pro-text">
            <p class="text1">【{{project.name}}】{{project.type}}</p>
            <p class="text2">{{project.desc}}</p>
            <p class="text3">可掌握的核心能力：</p>
            <p class="text4" v-html="project.abilityDesc"></p>
            <p class="text3">技术亮点：</p>
            <p class="text4" v-html="project.lightDesc"></p>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import check from "../../../utils/check";

export default {
  components: {
    pageTitle,
    swiper,
    swiperSlide,
  },
  mounted() {},

  data() {
    let that = this;
    return {
      show: false,
      projectList: [
        {
          name: '面试通',
          type: '内容阅读',
          img: require('../../../assets/coursePage/harmony/box5/面试通.png'),
          title: '【鸿蒙-面试通APP】',
          desc: '面试通APP提供了多种题目和内容，包括基础知识点问题、原理问题、项目问题等，满足不同程序员的需求。同时，面试通APP还包含各大公司的真实面试经验，便于用户找到心仪公司的面经。面试通APP支持用户自主选择学习内容，同时还提供了智能推荐和反馈机制，帮助用户更好地掌握知识和技能。主要功能：刷题系统、项目系统、面经系统、个人中心、历史记录等模块。',
          abilityDesc: '1. 能够实现鸿蒙应用界面的搭建和交互<br>2. 基于鸿蒙应用状态进行用户信息存储和访问权限控制<br>3. 能够封装基础数据源类完成长列表的性能优化<br>4. 能够通过设备查询完成多设备布局适配<br>5. 能够封装vp工具函数实现手机侧视觉一致<br>6. 能够基于Ability和Page生命周期实现数据埋点<br>7. 能够实现应用沙箱文件操作实现上传<br>8. 能够基于第三方模块完成日历组件封装<br>9. 能够封装本地库共享通用组件和函数',
          lightDesc: '·【企业范式】遵循华为项目开发范式，高可维护性<br>·【自研组件】openHarmony第三方中心仓组件共享<br>·【缓存技术】基于 Basic Services Kit 实现音频缓存<br>·【访问权限】基于 JWT 结合 ArkTS API 实现访问权限控制<br>·【性能优化】基于 LazyForEach 实现长列表性能优化<br>·【数据埋点】基于 Ability 和 Page 生命周期实现数据埋点<br>'
        },
        {
          name: '神领物流',
          type: '物流运输',
          img: require('../../../assets/coursePage/harmony/box5/神领物流.png'),
          title: '',
          desc: '神领物流是一款专业的物流智能系统，覆盖城配、城际、快递等多项业务，包括订单分配、智能调度、线路规划、运费模板、快递配送等核心功能，可实现整个物流快递业务的智能管理。神领物流鸿蒙司机端APP作为物流客户端，集成了任务调度、延迟收货上报异常、回车登记、消息通知、提货收货等主流的司机职能业务。',
          abilityDesc: '1. 能够掌握实现鸿蒙app应用搭建项目的基础架构<br>2. 能够掌握封装鸿蒙基础组件的开发能力<br>3. 能够掌握封装底层网络请求的能力<br>4. 能够掌握封装统一上传组件及预览图片的能力<br>5. 能够掌握Ability拉起调度并实现传值的能力<br>6. 能够掌握音频播放控制的能力<br>7. 能够掌握消息通知发送及接收的能力<br>8. 能够掌握混合开发双向通信的开发能力<br>9. 能够掌握地理位置定位及采用混合开发定位高德地图的能力<br>10. 能够掌握自定义弹窗插槽传入的开发能力<br>11. 能够掌握自定义系统UI日期弹窗的能力<br>',
          lightDesc: '·大型项目基础架构及目录的设计及拆分<br>·封装统一的可上传 可显示 可预览的统一图片上传组件<br>·大量复用自身封装的UI底层组件进行项目快速开发<br>·完整的司机端流程提货-接货-上报异常-回车登记业务<br>·混合开发双向通信机制的标准开发<br>·定位及传导web端定位需求<br>·定制化开发基础系统UI层基础层的基础组件'
        },
        {
          name: '黑马云音乐',
          type: '影音娱乐',
          img: require('../../../assets/coursePage/harmony/box5/黑马云音乐.png'),
          title: '',
          desc: '黑马云音乐是一款基于“赛博朋克”风格设计的音乐APP，包含歌单的分类展示，歌曲的播放，自定义专业播放界面，应用可以进行卡片的添加，可以让用户在视感和听感都得到极致的享受，卡片播功能也是简化了应用的使用复杂度，轻量级应用的操作，核心功能的使用，让用户能够快速进行体验。同时后台播放功能也可以在让喜欢听音乐的用户在进行其他操作的同时，仍然可以享受音乐带来的轻松和愉悦。',
          abilityDesc: '1. 掌握基于鸿蒙@ohos.animator进行播放动画同步<br>2. 掌握基于元服务进行卡片播放同步<br>3. 掌握基于AVPlayer媒体资源转码并通过输出设备播放<br>4. 掌握应用卡片添加、卡片通信、状态通知<br>5. 掌握状态持久化、后台任务创建销毁<br>',
          lightDesc: '·【AVPlayer】对状态机进行二次封装管理，实现播放模式控制、列表播放等功能<br>·【控制中心】音频播放接入控制中心，进行系统播放控制通知<br>·【后台播放】应用支持后台运行，防墓碑机制<br>·【个性动画】破坏风文字抖动、霓虹呼吸灯等动画效果<br>·【图片下载】对图片进行沙箱缓存，下载方案优化等<br>·【应用通信】实现控制中心、线程、进程之间通信方案并进行二次封装<br>·【音频合成】PCM格式音频录入、媒体类型转化、多音轨合成方案<br>'
        },
        {
          name: '享+生活',
          type: '生活服务',
          img: require('../../../assets/coursePage/harmony/box5/享生活.png'),
          title: '',
          desc: '享+社区是一个生活类的小程序项目，主要服务于小区业主，为其提供生活家电报修、访客门禁通行的功能，该项目主要包含房屋管理、报修管理、访客管理、用户管理、通知管理等功能模块，技术栈以Flutter实现多端跨平台开发。',
          abilityDesc: '1. 掌握 Dart 核心语法具备 Flutter 应用开发能力<br>2. 掌握 Flutter 跨平台能力开发鸿蒙APP能力<br>',
          lightDesc: '·学习 Flutter 如何快速构建高质量、漂亮、流畅的移动应用程序<br>·跨平台开发, 一套代码打包原生鸿蒙、安卓、iOS、Web<br>·全局状态和路由<br>'
        },
        {
          name: '翼康养老',
          type: '万物互联',
          img: require('../../../assets/coursePage/harmony/box5/翼康养老.png'),
          title: '',
          desc: '随着我国人口老龄化问题的日趋严峻，对专业化养老院的需求与日俱增。而大部分的养老院信息化水平较低，现代化服务装备普遍欠缺，管理和服务效率低下，无法满足老人对专业化护理的需求。翼康养老系统为养老院量身定制开发专业的养老管理软件产品，包含管理后台家属端小程序，员工管理端鸿蒙APP。主要功能：账号系统、预约登记系统、健康数据系统、护理工作台、IOT设备管理、员工中心等模块。',
          abilityDesc: '1. 掌握物联网APP开发相关知识<br>2. 掌握IOT设备识别和信息采集<br>3. 掌握IOT云平台的信息传输方式<br>4. 掌握华为统一认证用户登录<br>5. 掌握蓝牙识别IOT设备和安装<br>6. 掌握APP侧对感知设备的数据分析<br>7. 掌握APP侧对IOT设备下发命令<br>',
          lightDesc: '·【最新架构】使用Hsp三层架构，模块依赖分离、降低应用体积<br>·【账号服务】基于华为登录实现用户一键登录功能<br>·【物联网云平台】采用华为云IOTDA接入物联网产品与设备、支持设备侧基于MQTT协议上报、云侧指令下发<br>·【BLE蓝牙血糖仪】基于低功耗蓝牙标准数据协议实现鸿蒙应用侧与设备测通信，基于HTTPS协议应用侧上报数据<br>·【智能门禁】基于低功耗蓝牙JSON数据协议实现门禁WIFI扫描配网、蓝牙开锁、远程开锁、临时密码登功能<br>·【项目组件库】基于HarmonyOS Next封装项目特色组件，上传至第三方中心仓共享<br>'
        },
        {
          name: '优医问诊',
          type: '在线医疗',
          img: require('../../../assets/coursePage/harmony/box5/优医问诊.png'),
          title: '',
          desc: '优医问诊是一个连接医生和患者的移动医疗行业应用，通过高效、快速的在线问诊服务，为患者提供健康帮助，涵盖了找医生、快速问诊、开药门诊、疾病查询，健康百科等功能。该项目基于HBuilderX 使用 uni-app 开发跨端应用的能力，能够完成多端兼容、打包App、原生界面开发、地理定位、路径规划、即时通信。',
          abilityDesc: '1. 掌握uni-app跨平台开发框架核心使用<br>2. 掌握运用uni-app插件市场完成业务逻辑开发<br>3. 掌握微信支付和微信登录第三方能力调用<br>4. 基于vue3+ts以及周边生态完成项目开发<br>5. 能够运用小程序云开发完成项目相关业务<br>6. 能够基于websocket实现即时通信问诊室<br>7. 能够给予第三方地图完成药品物流轨迹绘制<br>',
          lightDesc: '·【最新技术栈】Vue3+TS+Pinia 前端最新最流行的技术栈<br>·【即时通信】基于 SocketIO 实现医生在线诊室医患聊天<br>·【高德地图】基于 AMap 路径规划、路径绘制实现物流<br>·【支付宝支付】基于支付宝沙箱支付实现问诊费用支付<br>·【跨平台开发】基于uni-app实现多端开发适配各类终端<br>'
        },
        {
          name: '美蔻商城',
          type: '电商购物',
          img: require('../../../assets/coursePage/harmony/box5/美蔻商城.png'),
          title: '',
          desc: '美蔻商城是一个"一对多"的电商购物应用，提供在线购物的核心服务，涵盖了商品列表、商品详情、购物车、商品评价、订单管理等功能。该项目基于鸿蒙一对多开发范式，采用了三层工程架构配合多种UI适配方式，最终实现"一次开发，多端部署的核心目标",同时也应用了鸿蒙系统的多种能力，比如多媒体技术，支付能力、混合开发等等。',
          abilityDesc: '1. 掌握三层架构的项目搭建方式<br>2. 掌握通用项目请求工具Logger工具的封装<br>3. 掌握在线购物的核心业务流程<br>4. 掌握基于鸿蒙的图片视频压缩技术<br>5. 掌握基础的Hybrid混合开发技术<br>6. 掌握分布式数据存储<br>7. 掌握拍照、视频等原生能力<br>8. 掌握服务卡片开发<br>9. 掌握设备断点多端适配技术<br>',
          lightDesc: '·【一次开发多端部署】媒体查询+栅格系统实现界面一多，SysCap实现功能一多，三层har架构实现工程一多<br>·【账号服务】基于华为登录实现用户一键登录功能<br>·【智能搜索】基于华为AI能力实现语音转文字，涉及录音和语音识别功能<br>·【物流轨迹】基于华为Map服务实现物流轨迹，涉及路径规划、轨迹绘制、地理定位功能<br>·【Hybird开发】基于Web组件实现客服系统与支付宝支付，涉及Web组件通信、Web资源监听能力<br>·【应用卡片】基于FormAbility实现商品推荐与物流状态卡，涉及卡片与宿主应用数据通信和交互<br>·【通用SKU组件】基于HarmonyOS Next封装通用能力组件，涉及使用sku算法实现规格可选功能<br>',
        },
        {
          name: '守护助手',
          type: '系统工具',
          img: require('../../../assets/coursePage/harmony/box5/守护助手.png'),
          title: '',
          desc: '守护助手是一款生活守护助手，让守护成为生活，24小时实时守护你的室内外安全。守护助手包括手机瘦身、骚扰拦截、隐私空间、通讯录备份、反诈中心、女性守护中心、权限管理等模块。',
          abilityDesc: '1. 掌握权限基本概念和工作流程<br>2. 掌握应用、硬件、地理位置等关键信息采集<br>3. 掌握录音、拍照、扫码的原生能力调用<br>4. 掌握图片、视频、音频等公共目录文件读写<br>5. 掌握电话、短信、通讯录等系统能力的调用<br>6. 掌握数据安全、身份认证等安全访问控制<br>7. 掌握消息通知、后台任务的能力调用<br>8. 掌握本地数据库、多线程的能力调用<br>',
          lightDesc: '·【隐私空间】通过 手势/指纹/面容ID 进行验证，加密存储照片、视频、录音、笔记确保隐私安全。<br>·【照片清理】定期清理相似或连拍照片，压缩手机中的大图片，解决手机空间不够用的烦恼。<br>·【联系人同步】通讯录一键体检优化，清理异常联系人，一键同步和恢复通讯录。<br>·【夜路守护】夜路导航，位置分享实时行踪监控，亲友同步，附近派出所提供 110 对接。<br>·【室内守护】伪装声音，伪装来电保护隐私，隐瞒独身，虚拟警报器，手机移动检测功能。<br>·【日历清理】添加重要日程，清理过期日程。<br>·【硬件信息】查询手机的型号，系统版本，启动时长，网络信息，剩余存储，传感器硬件支持情况。<br>·【权限管理】一键开启通知、位置、通讯录、相机、照片、麦克风、日历权限。<br>·【用户体验改进】应用崩溃时自动上传错误日志，监控应用安全运行。<br>'
        }
      ],
      project: {},
      cur: 0,
      scroll: 0,
      swiperOption: {
        loop: true, // 循环模式选项
        slidesPerView: "auto",
        spaceBetween: 15,
        centeredSlides: true,
        on: {
          slideChangeTransitionStart: function () {
            that.cur = this.realIndex;
            document.getElementsByClassName("scorll-box6")[0].scrollLeft =
              this.realIndex * 85;
            that.project = that.projectList[that.cur]; 
          },
          click(e) {
            if (e.target.className == "open") {
              that.show = true;
            }
          },
        },
      },
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },

    styleVar() {
      return {
        "--box-left": this.scroll + "px",
      };
    },
  },
  mounted() {
    this.project = this.projectList[this.cur]; 
  },
  methods: {
    showPop(){
      this.show = true,
      this.mai("鸿蒙-就业课","查看全部",0,this.projectList[this.cur].title)
    },
    changeCur(index) {
      this.swiper.slideTo(index, 0, false);
      this.cur = index;
      this.project = this.projectList[index];

      // 平滑滚动函数
      const scrollContainer = document.getElementsByClassName("scorll-box6")[0];
      if (scrollContainer) {
        const targetScrollLeft = index * 85;
        const startScrollLeft = scrollContainer.scrollLeft;
        const duration = 300; // 滚动动画时长，单位：毫秒
        const startTime = performance.now();

        const smoothScroll = (currentTime) => {
          const elapsedTime = currentTime - startTime;
          if (elapsedTime < duration) {
            const progress = elapsedTime / duration;
            scrollContainer.scrollLeft = startScrollLeft + (targetScrollLeft - startScrollLeft) * progress;
            requestAnimationFrame(smoothScroll);
          } else {
            scrollContainer.scrollLeft = targetScrollLeft;
          }
        };

        requestAnimationFrame(smoothScroll);
      }
    },
    close() {
      this.showVideo = false;
    },
    openDetail(name) {
      if (localStorage.getItem(`detail-${check.getUrlParam("nid")}`)) {
        window.location.href = localStorage.getItem(
          `detail-${check.getUrlParam("nid")}`
        );
      } else {
         this.clickZiXun()
      }
      this.mai("鸿蒙-就业课",name,0,null)
    },
  },
};
</script>

<style lang="less" scoped>
.box5 {
  padding: 80px 0 0;
  width: 100%;
  background: #fff;
  overflow: hidden;
  .van-popup {
    max-height: calc(100vh - 200px);
  }
  
  .nav-box::-webkit-scrollbar {
    display: none;
    width: 0 !important;
    height: 0 !important;
    color: transparent;
  }
  .scorll-box {
    position: absolute;
    left: 50%;
    margin-top: 32px;
    transform: translate(-50%, 0px);
    width: 78px;
    height: 6px;
    background: rgba(75, 132, 250, 0.16);
    border-radius: 3px;
    .scorll-block {
      position: absolute;
      left: var(--box-left);
      width: 20px;
      height: 6px;
      background: #4b84fa;
      border-radius: 3px;
    }
  }
  .subject-box {
    position: relative;
    margin: 40px auto 0;
    // padding-bottom: 22px;
    width: 100%;
    .swiperwrap {
      width: 686px;

      margin-top: 8px;
      img {
        width: 100%;
        height: 528px;
        object-fit: cover;
        border-radius: 16px;
      }
      .projectName {
        height: 48px;
        font-size: 32px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #1d2129;
        line-height: 48px;
        text-align: center;
        margin: 48px auto 16px;
      }
      .projectDesc {
        font-size: 28px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #86909c;
        line-height: 44px;
        background: linear-gradient(
          180deg,
          #86909c 0%,
          rgba(134, 144, 156, 0) 100%
        );
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
      .btn {
        width: 180px;
        height: 56px;
        background: linear-gradient(270deg, #4eacff 0%, #2674ff 100%);
        border-radius: 32px;
        font-size: 24px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 56px;
        text-align: center;
        margin: 24px auto 14px;
      }
    }

    .scorll-box6 {
      overflow-x: auto;
      width: 100%;
      box-sizing: border-box;
      &::-webkit-scrollbar {
        display: none;
        width: 0 !important;
        height: 0 !important;
        color: transparent;
      }
    }
    .nav-box {
      width: 1400px;
      position: relative;
      padding-bottom: 20px;
      display: flex;
      justify-content: space-between;
      font-family: PingFang SC;
      font-size: 24px;
      font-weight: 400;
      color: #1d2129;
      .gray {
        position: absolute;
        width: 100%; // 设置宽度和父元素 .nav-box 相同
        height: 20px;
        background: #E6E9FA;
        bottom: 0;
      }
      .nav {
        position: relative;
        padding: 20px 30px;
        background: #ffffff;
        border-radius: 8px;
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 600;
        color: #000D4D;
        line-height: 28px;
        text-align: center;
        flex-shrink: 0;
        // 添加过渡效果
        transition: all 0.3s ease; 
        &::before {
          opacity: 0;
          content: "";
          position: absolute;
          left: 50%;
          transform: translate(-50%, 0px);
          bottom: 0;
          width: 60%;
          height: 4px;
          background: #002BFF;
          transition: opacity 0.3s ease;
        }
        &::after {
          opacity: 0;
          z-index: 100;
          content: "";
          position: absolute;
          left: 0;
          right: 0;
          bottom: -10px;
          margin: 0 auto; 
          width: 0;
          height: 0;
          border-left: 10px solid transparent; 
          border-right: 10px solid transparent; 
          border-top: 10px solid #002BFF;
          transition: opacity 0.3s ease;
        }
      }

      .cur-nav {
        position: relative;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #002AFE;
        &::before {
          opacity: 1;
        }
        &::after {
          opacity: 1;
        }
      }
    }
    .swiper-box {
      padding: 20px 0 80px;
      background: #E6E9FA;
    }
  }

  .swiperwrap {
    width: 630px !important;
  }
  .item-wrapper{
    width: 630px;
    .item{
      box-sizing: border-box;
      height: 900px;
      width: 630px;
      background: #ffffff;
      border-radius: 30px;
      padding: 50px 30px 0 30px;
      margin-bottom: 50px;
      img{
        display: block;
        margin-left: 55px;
        width: 537px;
      }
      .text1{
        font-weight: 600;
        font-size: 36px;
        color: #002BFF;
        margin-bottom: 20px;
      }
      .text2{
        font-size: 24px;
        color: #474D66;
      }
      .expand{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        position: absolute;
        width: 630px;
        left: 0;
        right: 0;
        bottom: 0px;
        border-radius: 30px;
        height: 150px;
        background: linear-gradient(rgba(255, 255, 255, 0.7) 0%, rgba(255, 255, 255, 1) 50%, rgba(255, 255, 255, 1) 100%);
        .line{
          width: 15px;
          height: 15px;
          border: 3px solid #002BFF;
          border-top: none;
          border-right: none;
          transform: rotate(-45deg);
        }
        span{
          margin-top: 20px;
          font-weight: 500;
          font-size: 26px;
          color: #002BFF;
        }
      }
    }
  } 

  .project-wrapper{
    max-height: calc(100vh - 200px);
    .project-content{
      max-height: calc(100vh - 200px);
      position: relative;
      overflow-x: hidden;
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
      z-index: 100;
      .pro-img{
        width: 750px;
        height: 622px;
        background: #E0E6FF;
        border-radius: 30px 30px 0 0;
        overflow: hidden;
        .img1-wrapper{
          display: flex;
          flex-direction: row-reverse;
          padding: 30px;
        }
        .img1{
          width: 35px;
        }
        .img2{
          width: 570px;
          margin-left: 140px;
        }
      }
      .pro-text{
        padding: 50px;
        background: #fff;
      }
      .text1{
        font-weight: 600;
        font-size: 36px;
        color: #002BFF;
      }
      .text2{
        font-size: 24px;
        margin: 30px 0 40px 0;
        color: #474D66;
        line-height: 40px;
      }
      .text3{
        font-size: 24px;
        margin: 30px 0;
        font-weight: 500;
        font-size: 26px;
        color: #000D4D;
      }
      .text4{
        font-size: 24px;
        color: #474D66;
        line-height: 40px;
      }
      // &::-webkit-scrollbar {
      //   width: 6px;		
      //   height: 300px !important;
      // }
      
      // &::-webkit-scrollbar-thumb {
      //   background: #99AAFF; /* 设置滑块背景颜色 */
      //   border-radius: 2px; /* 设置滑块圆角 */
      // }
    }
  }
  .seek-btn {
    margin: 50px auto 0;
    width: 570px;
    height: 88px;
    background: linear-gradient(0deg, #FF6C47 1%, #FF5A47 100%);
    border-radius: 44px;
    font-weight: 600;
    font-size: 30px;
    color: #FFFFFF;
    line-height: 88px;
    text-align: center;
  }
}
</style>
